import { Fragment } from 'react';
import { Button } from '@schibsted-svp/react-ui';

import type { Dispatch, FC, SetStateAction } from 'react';

import styles from './TablePagination.module.scss';

type Props = {
  currentPage: number;
  pagesLength: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  [key: string]: unknown;
};

const TablePagination: FC<Props> = ({
  currentPage,
  pagesLength,
  setCurrentPage,
}) => {
  return (
    <div className={styles.pagination}>
      {pagesLength > 1 && (
        <Fragment>
          <Button
            type="button"
            size="small"
            variant="standard"
            disabled={currentPage === 0}
            onClick={() => {
              setCurrentPage(currentPage - 1);
            }}
          >
            Previous page
          </Button>
          <div className={styles.counter}>
            {currentPage + 1} / {pagesLength}
          </div>
          <Button
            type="button"
            size="small"
            variant="standard"
            disabled={currentPage === pagesLength - 1}
            onClick={() => {
              setCurrentPage(currentPage + 1);
            }}
          >
            Next page
          </Button>
        </Fragment>
      )}
    </div>
  );
};

export { TablePagination };
